import type { Messages } from "../../catalog";

export const viewerMessages = {
  "{count} comments": { one: "{count} comment", other: "{count} comments" },
} satisfies Messages;
